<script>
import { watch, } from 'vue'
import Overlay from '@/assets/js/src/components/Overlay.vue'
import ButtonGroupCancelApply from '@/assets/js/src/components/ButtonGroupCancelApply.vue'
import ClaimDialog from '@/assets/js/src/components/ClaimDialog.vue'
import LoadingDummyH1 from '@/assets/js/src/components/loading/LoadingDummyH1'
import LoadingDummyP from '@/assets/js/src/components/loading/LoadingDummyP'
import LoadingDummySelect from '@/assets/js/src/components/loading/LoadingDummySelect'
import LoadingDummyCustom from '@/assets/js/src/components/loading/LoadingDummyCustom'
import { usePrefetchData, } from '@/assets/js/src/util/composables/usePrefetchData'
import { getActivePinia, storeToRefs, } from 'pinia'
import { useAppUiStore, } from '@/assets/js/src/pinia/appUi'
import { useOverlayRouteAction, } from '@/assets/js/src/util/composables/useOverlayRouteAction'
import { useContactForm, } from '@/assets/js/src/modules/contact/_composables/useContactForm'
import { useClaim, } from '@/assets/js/src/modules/contact/_composables/useClaim'
import { useTranslation, } from '@/assets/js/src/util/composables'
import { useHeadInfoTitle, } from '@/assets/js/src/layout/useHeadInfo'

export default {
    name: 'Contact',
    components: {
        LoadingDummyCustom,
        LoadingDummySelect,
        LoadingDummyP, LoadingDummyH1, ClaimDialog, ButtonGroupCancelApply, Overlay, },
    beforeRouteLeave (to, from, next) {
        this.$refs.claimDialog.beforeRouteLeave (to, from, next)
    },
    setup () {
        const { messagesLoaded, } = usePrefetchData({
            loadAsyncMessages: [ 'contact', 'common', 'user', ],
        })
        const { cancel, } = useClaim()
        const {
            valid,
            email,
            emailRules,
            name,
            text,
            runningApiCall,
            textRules,
            submit,
        } = useContactForm({ onSuccess:cancel, })

        const { claim, } = storeToRefs(useAppUiStore(getActivePinia()))
        
        watch(text, (newValue) => {
            claim.value = newValue && newValue.length !== 0
        })

        const { title, } = useHeadInfoTitle({
            titleKey: 'async.contact.title',
            descriptionKey: 'async.contact.meta_description',
        })

        return {
            messagesLoaded,
            ...useOverlayRouteAction(),
            ...useTranslation(),
            cancel,
            title,
            valid,
            email,
            emailRules,
            name,
            text,
            runningApiCall,
            textRules,
            submit,
        }
    },
}
</script>

<template>
    <overlay class-name="contact-view">
        <h1
            v-if="messagesLoaded"
            class="mb-4 hidden-print-only"
        >
            {{ title }}
        </h1>
        <loading-dummy-h1
            v-else
        ></loading-dummy-h1>
        <p
            v-if="messagesLoaded"
        >
            {{ t('async.contact.intro') }}
        </p>
        <loading-dummy-p
            v-else
        ></loading-dummy-p>
        <v-form
            id="contact"
            ref="form"
            v-model="valid"
        >
            <v-row>
                <v-col
                    cols="12"
                    md="6"
                    class="contact-view__name"
                >
                    <!--Password -->
                    <v-text-field
                        v-if="messagesLoaded"
                        v-model="name"
                        clear-icon
                        color="primary"
                        bg-color="background"
                        :label="t('async.contact.form.name')"
                    ></v-text-field>
                    <loading-dummy-select
                        v-else
                    ></loading-dummy-select>
                </v-col>
                <v-col
                    cols="12"
                    md="6"
                    class="contact-view__email"
                >
                    <v-text-field
                        v-if="messagesLoaded"
                        v-model="email"
                        :rules="emailRules"
                        color="primary"
                        bg-color="background"
                        :label="t('async.contact.form.email')"
                        type="email"
                    ></v-text-field>
                    <loading-dummy-select
                        v-else
                    ></loading-dummy-select>
                </v-col>
                <v-col
                    cols="12"
                    class="contact-view__text"
                >
                    <v-textarea
                        v-if="messagesLoaded"
                        v-model="text"
                        :label="t('async.contact.form.text')"
                        auto-grow
                        color="primary"
                        bg-color="background"
                        :rules="textRules"
                        maxlength="5000"
                    ></v-textarea>
                    <loading-dummy-custom
                        v-else
                        height="168px"
                    ></loading-dummy-custom>
                </v-col>
                <v-col
                    cols="12"
                    class="contact-view__submit"
                >
                    <button-group-cancel-apply
                        v-if="messagesLoaded"
                        :apply-label="t('async.contact.form.submit')"
                        :loading="runningApiCall"
                        :disabled="runningApiCall || !valid"
                        @apply="submit"
                        @cancel="cancel"
                    ></button-group-cancel-apply>
                    <loading-dummy-custom
                        v-else
                        wifth="200px"
                        height="56px"
                        class="contact-view__submit--loading"
                    ></loading-dummy-custom>
                </v-col>
            </v-row>
        </v-form>
        <claim-dialog
            v-if="messagesLoaded"
            ref="claimDialog"
        ></claim-dialog>
    </overlay>
</template>

<style lang="scss">
.bs-app .contact-view {
    &__submit {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
